export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-brush/src/constant.js
// module id = 1406
// module chunks = 0